/**
 * React Query hooks for exercise logging endpoints.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuthenticatedQuery } from "./useAuthenticatedQuery";
import {
  fetchExerciseHistory,
  logExercises,
  type ExerciseLogBatchCreate,
} from "@/lib/exerciseApi";

const KEYS = {
  exerciseHistory: "exerciseHistory",
} as const;

export function useExerciseHistory(exerciseName: string | null, limit = 50) {
  return useAuthenticatedQuery({
    queryKey: [KEYS.exerciseHistory, exerciseName, limit],
    queryFn: () => fetchExerciseHistory(exerciseName!, limit),
    enabled: !!exerciseName,
    staleTime: 2 * 60 * 1000,
  });
}

export function useLogExercises() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: ExerciseLogBatchCreate) => logExercises(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [KEYS.exerciseHistory] });
    },
  });
}
